import { render, staticRenderFns } from "./ModalEmailDeconnected.vue?vue&type=template&id=4bed40a3&scoped=true&"
import script from "./ModalEmailDeconnected.vue?vue&type=script&lang=js&"
export * from "./ModalEmailDeconnected.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmailDeconnected.vue?vue&type=style&index=0&id=4bed40a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed40a3",
  null
  
)

export default component.exports